import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import InfoIcon from "../../../../../../../../assets/images/icons/InfoIcon";
import BriaTooltip from "../../../../../../../../components/common/BriaTooltip/BriaTooltip";
import FileUploader from "../../../../../../../../components/common/FileUploader/FileUploader";
import { useAppStore } from "../../../../../../../../hooks/useStores";
import { isAdsEditor } from "../../../../../../../../utils";
import useDesignEditorUtils from "../../../../../../../CustomUtils/UseDesignEditor";
import UseAdsEditorUtils from "../../../../../../../hooks/useAdsEditorUtils";
import { useEditor } from "../../../../../../../hooks/useEditor";
import { LayerType } from "../../../../../../../types";
import { toBase64 } from "../../Uploads";
import styles from "./AdsEditorUploadImages.module.scss";

const AdsEditorUploadImages = () => {
	const { t } = useTranslation("translation", { keyPrefix: "editor.images" });
	const { campaignStore } = useAppStore();
	const { addImageObjectToCanvas } = useDesignEditorUtils();
	const { getFirstAvailableConfig, getFabricLayerTakenConfigs } = UseAdsEditorUtils();
	const editor = useEditor();
	const [isImageLoading, setIsImageLoading] = useState<boolean>(false);

	const handleUploadImageAndadditToCanvas = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const _currentScene = editor?.scene.exportToJSON();
		if (_currentScene) {
			setIsImageLoading(true);
			if (!isAdsEditor()) {
				const usedConfigs = getFabricLayerTakenConfigs(_currentScene?.layers, LayerType.STATIC_IMAGE, false);
				const firstAvailableConfig = getFirstAvailableConfig(usedConfigs, LayerType.STATIC_IMAGE);
				if (!firstAvailableConfig) {
					campaignStore.setProperty("nonAvailableConfigSnackbarOpen", true);
					return;
				}
			}
			const file = e.target.files?.[0];
			if (!file) return;

			const imageUrl = (await toBase64(file)) as string;
			if (imageUrl) {
				const newImageToAdd = {
					id: "",
					visual_hash: "",
					url: imageUrl,
					isLogo: false,
				};
				addImageObjectToCanvas(newImageToAdd);
			}
			setIsImageLoading(false);
		}
	};

	return (
		<Box className={styles.uploadImageWrapper}>
			<Box className={styles.uploadImageTextIconWrapper}>
				<Typography className={styles.uploadImageText}>{t("uploadImage")}</Typography>
				<BriaTooltip
					title={t("toolTip")}
					className={styles.info}
					componentsProps={{ tooltip: { className: styles.tooltip } }}
					displayOn="hover"
				>
					<InfoIcon className={styles.infoIcon} />
				</BriaTooltip>
			</Box>
			<FileUploader
				buttonText={"Upload"}
				buttonType="primaryMedium"
				inputProps={{ accept: "image/png, image/jpeg, image/jpg, image/webp" }}
				onUpload={handleUploadImageAndadditToCanvas}
				buttonClassName={clsx(styles.primaryButton, {
					[styles.disabled]: false,
				})}
				loading={isImageLoading}
				disabled={isImageLoading}
			/>
		</Box>
	);
};
const ObservedComponent = observer(AdsEditorUploadImages);
export default ObservedComponent;
